import { render, staticRenderFns } from "./AddContactPaginationControl.vue?vue&type=template&id=6ddfbfcc&scoped=true"
import script from "./AddContactPaginationControl.vue?vue&type=script&lang=js"
export * from "./AddContactPaginationControl.vue?vue&type=script&lang=js"
import style0 from "./AddContactPaginationControl.vue?vue&type=style&index=0&id=6ddfbfcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddfbfcc",
  null
  
)

export default component.exports